import type { WorkbenchTimelineObjectRef } from '@shared/business-workbench/workbench-timeline-event';

export const WORKBENCH_TIMELINE_INVALIDATED = 'inflomatrix:workbench-timeline-invalidated';

export interface WorkbenchTimelineInvalidatedDetail {
  objectRef: WorkbenchTimelineObjectRef;
}

export function emitWorkbenchTimelineInvalidated(objectRef: WorkbenchTimelineObjectRef): void {
  if (typeof window === 'undefined') {
    return;
  }
  const detail: WorkbenchTimelineInvalidatedDetail = { objectRef };
  window.dispatchEvent(
    new CustomEvent<WorkbenchTimelineInvalidatedDetail>(WORKBENCH_TIMELINE_INVALIDATED, {
      detail,
    })
  );
}

export function matchesWorkbenchTimelineObjectRef(
  left: WorkbenchTimelineObjectRef,
  right: WorkbenchTimelineObjectRef
): boolean {
  return (
    left.domain === right.domain &&
    left.objectType === right.objectType &&
    left.objectId === right.objectId
  );
}
